import translations from './translations'
import dataLayer from '../core/dataLayer'
import isInApp from '../core/isInApp'

class Nespresso {
    constructor () {
        this.platform = isInApp ? 'native' : dataLayer.platform
        this.prefix = dataLayer.channel === 'B2B' ? '/pro' : ''
        this.sdk = null
        translations.setToSkip({
            keys: ['images', 'ingredients', 'quantities', 'technologies', 'category', 'legacyId', 'pdpURL', 'rootCategory', 'salesMultiple', 'unitQuantity', 'urlFriendlyName', 'pdpURLs']
        })
    }

    ready () {
        let promise = this.promise
        if (!promise) {
            if (isInApp) {
                promise = this.load()
            } else {
                const sdk = window.napi
                this.sdk = sdk
                /* istanbul ignore if */
                if (process.env.NODE_ENV === 'development') {
                    promise = Promise.resolve(sdk)
                } else {
                    promise = sdk
                        .initialize(dataLayer.channel, dataLayer.country, dataLayer.language, this.platform, this.prefix)
                        .then(() => sdk)
                }
            }
            this.promise = promise
        }
        return promise
    }

    load () {
        if (!Nespresso.sdkPromise) {
            Nespresso.sdkPromise = import(/* webpackChunkName: "getScript" */ '../utils/getScript')
                .then(getScript => getScript.default('https://www.nespresso.com/api/e-commerce/v2/js/customer-v2.js')
                    .then(() => {
                        const sdk = this.sdk = window.nespresso
                        return sdk
                            .initialize(dataLayer.channel, dataLayer.country, dataLayer.language, this.platform, this.prefix)
                            .then(() => sdk)
                            .catch(() => {
                                throw new Error('unable to initialize nespresso sdk')
                            })
                    })
                    .catch(() => {
                        throw new Error('unable to load nespresso sdk')
                    }))
        }
        return Nespresso.sdkPromise
    }

    getProduct (sku) {
        sku = sku.trim()
        return this
            .ready()
            .then(sdk => Promise.all([
                sdk.catalog().getProduct(sku),
                sdk.priceFormat(),
                sdk.catalog().getPrices(),
                sdk.catalog().getStocks()
            ])
                .then(([data, priceFormat, dataPrices, dataStocks]) => {
                    const product = JSON.parse(JSON.stringify(data))
                    // if there is html content in the description, it will load the images in the content,
                    // sometimes, not wanted
                    if (!translations.getApiDescription && product.hasOwnProperty('description')) {
                        delete product.description
                    }
                    translations.mutate(product)
                    product.price = dataPrices.prices[product.id]
                    product.pdpURL = isInApp ? '#' : data.pdpURLs[this.platform]
                    product.inStock = dataStocks[product.id]
                    product.currencySymbol = priceFormat.currency(dataPrices.currency)
                    product.displayedPrice = priceFormat.short(product.currencySymbol, product.price)
                    return product
                })
                .catch(() => {
                    throw new Error(`getProduct fail on sku ${sku}`)
                }))
    }

    addToCart (sku, quantity) {
        return this
            .ready()
            .then(sdk => sdk.cart()[isInApp ? 'add' : 'update'](sku, quantity))
            .catch(() => {
                throw new Error(`unable to add to cart product ${sku}, ${quantity} quantity`)
            })
    }

    readCart () {
        return this
            .ready()
            .then(sdk => {
                if (isInApp) {
                    return []
                } else {
                    return sdk.cart().read({ forceRefresh: true })
                }
            })
            .catch(() => {
                throw new Error('unable to read the cart')
            })
    }
}

Nespresso.sdkPromise = null

export default Nespresso
